var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Manual",
  width: 18,
  height: 16,
  viewBox: "0 0 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_44178",
  "data-name": "Path 44178",
  d: "M72.735,94.65H69.571v3.428h3.164Zm-1.055,2.286H70.626V95.792h1.055Zm0,0",
  transform: "translate(-57.917 -86.649)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_44179",
  "data-name": "Path 44179",
  d: "M14.818,1.143V0H11.654V1.143H10.368A1.824,1.824,0,0,0,9,1.776a1.824,1.824,0,0,0-1.368-.633H0V16H18V1.143Zm-2.109,0h1.055V5.715H12.709ZM10.368,2.285h1.287V6.857h3.164V2.285h2.127V12.572H10.368a1.766,1.766,0,0,0-.84.213V3.195A.878.878,0,0,1,10.368,2.285Zm-2.735,0a.878.878,0,0,1,.84.91v9.591a1.766,1.766,0,0,0-.84-.213H1.055V2.285ZM1.055,13.714H7.632a.878.878,0,0,1,.84.91v.234H1.055Zm8.473,1.144v-.234a.878.878,0,0,1,.84-.91h6.578v1.144Zm0,0"
})));

export default __webpack_public_path__ + "static/media/Manual.ee49f6a9.svg";
export { SvgComponent as ReactComponent };